import React, { useState } from "react";
import Selector from "@ui/Selector";
import t from "../../../i18n";
import { HIDE_ON_WIDGET_EXPORT } from "@ui/ExportWidgetButton";

export type DisplayMode = "matrix" | "chart";

interface ReparabilityMatrixSelectorProps {
  value?: DisplayMode;
  onChange?: (value: DisplayMode) => void;
}

function ReparabilityMatrixSelector({ value, onChange }: ReparabilityMatrixSelectorProps) {
  const [internalDisplayMode, setInternalDisplayMode] = useState<DisplayMode>("matrix");

  const displayMode = value === undefined ? internalDisplayMode : value;
  const setDisplayMode = (value: DisplayMode) => {
    if (onChange) {
      onChange(value);
    } else {
      setInternalDisplayMode(value);
    }
  };

  return (
    <Selector
      options={[
        { value: "matrix", label: t("reporting.chart.switch.matrix") },
        { value: "chart", label: t("reporting.chart.switch.chart") },
      ]}
      value={displayMode}
      onChange={setDisplayMode as (value: string) => void}
      className={HIDE_ON_WIDGET_EXPORT}
      data-testid="reparability-view-selector"
    />
  );
}

export default React.memo(ReparabilityMatrixSelector);
